import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css";
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { getLink, handleQuestionUpdate, handleSelectAll, ImageModal, isErrorQuestion, Loader, SolutionModal, validateQuestionData } from '../../components/ModalsCommonFunctions';
import ViewImageAndText from '../../components/ViewImageAndText';

const SectionUplaodTextBook = () => {
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const inputRef = useRef(null);

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicMasterId: '',
        instituteSubjectMasterId: '',
        importFile: "",
        questionData: []
    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicList, setSubTopicList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [filterbook, setFilterBook] = useState(initialFormState)

    const [questionList, setQuestionList] = useState([])
    const [errorQuestions, setErrorQuestions] = useState({})
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalData, setModalData] = useState("")
    const [visibleSolution, setVisibleSolution] = useState(false);
    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result);
            })
            .catch(error => {
                setSyllabusList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilterBook((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        const { name, value } = e.target;
        setFilterBook((prevData) => {
            return {
                ...prevData,
                [name]: value,
                sectionLessonMasterId: '',
                sectionTopicMasterId: '',
                sectionSubTopicMasterId: '',
                instituteSubjectMasterId: '',
            }
        })

        const apiUrl2 = `/get-section-syllabus-structure-Wise-section-subjects?id=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                setSubjectList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        const { name, value } = e.target;
        setFilterBook((prevData) => {
            return {
                ...prevData,
                [name]: value,
                sectionLessonMasterId: '',
                sectionTopicMasterId: '',
                sectionSubTopicMasterId: '',
            }
        })
        const apiUrl = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${filterbook.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                setLessonList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        const { name, value } = e.target;
        setFilterBook((prevData) => {
            return {
                ...prevData,
                [name]: value,
                sectionTopicMasterId: '',
                sectionSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                setTopicList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        const { name, value } = e.target;
        setFilterBook((prevData) => {
            return {
                ...prevData,
                [name]: value,
                sectionSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${filterbook.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${filterbook.instituteSubjectMasterId}&sectionLessonMasterId=${filterbook.sectionLessonMasterId}&sectionTopicMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubTopicList(response.data.result)
            })
            .catch(error => {
                setSubTopicList([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleUploadQuestion = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        let fileExtension = file.name.split(".").pop().toLowerCase();
        const body = new FormData();
        body.append("file", file);

        setFilterBook(prevData => ({
            ...prevData,
            questionData: []
        }))

        if (fileExtension == "xlsx" || fileExtension === "docx") {
            setLoading(true);

            try {
                const link = await getLink(e.target.name, body, setFilterBook);
                if (!link) throw new Error('Link not generated');

                const endpoint = fileExtension === "docx"
                    ? "convert-question-bank-docx"
                    : "convert-question-bank-xlsx-v2";

                const payload = fileExtension === "docx"
                    ? { "wordFilePath": link }
                    : { "excelFilePath": link };

                const response = await authorizedAxiosCommon.post(endpoint, payload);
                setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire(
                { text: "Only xlsx, docx file supported" }
            );
        }
    }

    const validateForm = () => {
        const filterbookDataValid = Object.entries(filterbook).every(([key, value]) => {
            if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '') {
                        return false;
                    }
                }
            }
            return true;
        });

        const isQuestionDataNotEmpty = filterbook.questionData.length > 0;

        // Only validate `questionData` if `importFile` is not empty and is a .docx file
        if (filterbook.importFile !== '' && filterbook.importFile.length !== 0) {
            if (!isQuestionDataNotEmpty) {
                return false; // Return false if `questionData` is empty when it should not be
            }
        }

        return filterbookDataValid;
    };


    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            const newErrors = {};

            // Validate each field in filterbook
            for (const [key, value] of Object.entries(filterbook)) {
                if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                    if (typeof value === 'string' && value.trim() === '') {
                        newErrors[key] = 'This field is required.';
                    } else {
                        newErrors[key] = ''; // Clear error if field is valid
                    }
                }
            }

            const isQuestionDataNotEmpty = filterbook.questionData.length > 0;

            if (filterbook.importFile !== '' && filterbook.importFile.length !== 0) {
                if (!isQuestionDataNotEmpty) {
                    newErrors['questionData'] = 'At least one question is required.';
                } else {
                    newErrors['questionData'] = '';
                }
            }

            setError(newErrors);
        }
    }, [filterbook]);

    const callQuestionBankSaveApi = (apiUrl, data) => {
        return authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, data)
            .then(response => {
                setFilterBook((prevData) => {
                    return {
                        ...prevData,
                        importFile: "",
                        questionData: []
                    }
                })
                setErrorQuestions({});
                setQuestionList([]);
                inputRef.current.value = '';
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    const saveQuestions = () => {
        if (!validateForm()) {
            handleFormErrors();
            setLoading(false);
            return;
        }

        setLoading(true);
        let data = { ...filterbook };
        const fileExtension = filterbook.importFile.split('.').pop().toLowerCase();
        delete data.importFile;

        const questionIds = validateQuestionData(filterbook.questionData, false);
        if (questionIds.errorCount > 0) {
            handleQuestionErrors(questionIds.errorquestionIds);
            setLoading(false);
            return;
        }

        const apiUrl = fileExtension === "docx"
            ? '/import-question-bank-docx'
            : '/import-question-bank-xlsx';

        callQuestionBankSaveApi(apiUrl, data)
            .finally(() => {
                setLoading(false); // End loading
            });
    };

    const handleFormErrors = () => {
        const newErrors = {};

        for (const [key, value] of Object.entries(filterbook)) {
            if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                newErrors[key] = typeof value === 'string' && value.trim() === '' ? 'This field is required.' : '';
            }
        }

        if (filterbook.importFile !== '' && filterbook.questionData.length === 0) {
            newErrors['questionData'] = 'At least one question is required.';
        } else {
            newErrors['questionData'] = '';
        }

        setError(newErrors);
    };

    const handleQuestionErrors = (errorQuestionIds) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.no === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');

        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;
        Swal.fire({ text: message });
    };

    const getFileName = (path) => {
        let i = path.length - 1;
        let name = "";
        while (i >= 0 && path[i] !== "/") {
            name = path[i] + name;
            i--;
        }

        return name;
    }

    const handleInputReset = () => {
        setFilterBook(initialFormState);
        setQuestionList([]);
        setErrorQuestions({})
        inputRef.current.value = '';
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Upload</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Upload Text Book</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={filterbook.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={filterbook.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={filterbook.sectionLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionLessonMasterId && <p style={{ color: 'red' }}>{error.sectionLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleTopicChange} value={filterbook.sectionTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionTopicMasterId && <p style={{ color: 'red' }}>{error.sectionTopicMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSubTopicMasterId' onChange={handleInputChange} value={filterbook.sectionSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSubTopicMasterId && <p style={{ color: 'red' }}>{error.sectionSubTopicMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Text Book Question Bank :<span style={{ color: "red" }}>only xlsx & docx file supported</span></label>
                                                    <input required type="file" className="form-control" name="importFile" onChange={handleUploadQuestion} ref={inputRef} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={saveQuestions}>Save</button>
                                            </div>

                                            {visibleSolution && <SolutionModal visibleSolution={visibleSolution} setVisibleSolution={setVisibleSolution} modalData={modalData} />}

                                            {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}


                                            {questionList.length !== 0 && <div className="d-grid gap-2 mt-2">
                                                <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                    <div>
                                                        {errorQuestions.errorCount > 0 && (
                                                            <div className="alert alert-danger" role="alert">
                                                                {errorQuestions.errorCount === 1 ?
                                                                    `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                    `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                    {error.questionData && <p style={{ color: 'red' }}>{error.questionData}</p>}
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                {questionList?.length > 0 && <th>
                                                                    <input
                                                                        type='checkbox'
                                                                        checked={filterbook.questionData.length === questionList.length}
                                                                        onClick={() => handleSelectAll(questionList, filterbook, setFilterBook)}
                                                                    /> All
                                                                </th>}
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope='col'>Q_Level</th>
                                                                <th scope='col'>Q_Type</th>
                                                                <th scope='col'>Question</th>
                                                                <th scope="col">Option_a</th>
                                                                <th scope="col">Option_b </th>
                                                                <th scope="col">Option_c</th>
                                                                <th scope="col">Option_d</th>
                                                                <th scope='col'>Answer</th>
                                                                <th scope='col'>Solution</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                questionList?.length > 0 ?
                                                                    questionList?.map((question, index) => {
                                                                        const rowClass = isErrorQuestion(errorQuestions, question) ? 'error-row' : '';
                                                                        return (
                                                                            <tr key={index} className={rowClass}>
                                                                                <td><input type='checkbox' checked={filterbook.questionData.some(q => q.no === question.no)} onChange={() => handleQuestionUpdate(question, filterbook, setFilterBook)} /></td>
                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                <td>E</td>
                                                                                <td>S</td>
                                                                                {/* <td><ViewImageAndText inputString={question.question} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['a)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['b)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['c)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['d)']} onViewImage={onViewImage} /></td> */}
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['a)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['b)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['c)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['d)'] }} /></td>
                                                                                <td>{question.answer}</td>
                                                                                <td>
                                                                                    <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                        setVisibleSolution(!visibleSolution)
                                                                                        setModalData(question.solution)
                                                                                    }}><i class="fa fa-eye" ></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionUplaodTextBook;